import { useEffect, useState } from "react";
import { getPublicStatus } from "../lib/api";
import { useRole } from "../hooks/useRole";
import { Icon } from "./Common.jsx";

// Polls the public platform status. When maintenance mode is on, every role
// EXCEPT platform admin sees a full-screen maintenance page instead of the app.
// Admins keep working so they can flip the switch back off.
export default function MaintenanceGate({ children }) {
  const role = useRole();
  const [maint, setMaint] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const poll = () => {
      getPublicStatus()
        .then((s) => { if (!cancelled) setMaint(s?.maintenance || null); })
        .catch(() => {});
    };
    poll();
    const id = setInterval(poll, 30_000);
    return () => { cancelled = true; clearInterval(id); };
  }, []);

  const blocked = maint?.enabled && role !== "admin";
  if (!blocked) return children;

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
        background: "var(--bg, var(--surface))",
      }}
    >
      <div
        className="card"
        style={{ maxWidth: 460, textAlign: "center", padding: "40px 32px" }}
      >
        <div
          style={{
            width: 64, height: 64, borderRadius: 18, margin: "0 auto 20px",
            display: "grid", placeItems: "center",
            background: "rgba(245,158,11,.14)", color: "#F59E0B",
          }}
        >
          <Icon name="construction" size={30} />
        </div>
        <h1 style={{ fontSize: 22, fontWeight: 700, margin: "0 0 10px" }}>
          Down for maintenance
        </h1>
        <p style={{ fontSize: 14, color: "var(--text-muted)", lineHeight: 1.6, margin: 0 }}>
          {maint.message ||
            "We're performing scheduled maintenance and will be back shortly. Thanks for your patience."}
        </p>
        <button
          className="btn btn-ghost"
          style={{ marginTop: 24 }}
          onClick={() => window.location.reload()}
        >
          <Icon name="refresh-cw" size={14} /> Try again
        </button>
      </div>
    </div>
  );
}
